import { memo } from 'react';
import { Box, Button } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import ConfirmationModalView from '../v2-common/ConfirmationModalView';
import { useDeleteSectionButtonViewModel } from './DeleteSectionButtonViewModel';

interface DeleteSectionButtonProps {
  readonly currentPage: ContentNode;
  readonly currentSection: ContentNode;
  /** Plain-text title shown in the confirmation message. */
  readonly sectionTitle: string;
}

const DeleteSectionButton = memo(function DeleteSectionButton({
  currentPage,
  currentSection,
  sectionTitle,
}: DeleteSectionButtonProps) {
  const vm = useDeleteSectionButtonViewModel(currentPage, currentSection);

  return (
    <>
      <Button variant="icon" iconName="remove" ariaLabel="Delete section" onClick={vm.openModal} />
      {vm.isModalVisible && (
        <ConfirmationModalView
          header="Delete Section"
          body={
            <Box>Delete section &quot;{sectionTitle}&quot;? This operation cannot be undone.</Box>
          }
          confirmLabel="Delete"
          isConfirming={vm.isDeleting}
          onDismiss={vm.dismissModal}
          onConfirm={vm.confirmDelete}
        />
      )}
    </>
  );
});

export default DeleteSectionButton;
